import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  submit(event) {
    // Pour les champs de saisie, on ajoute un délai
    if (event.type === "input") {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, this.delayValue)
    } else {
      // Pour les autres événements (change), soumission immédiate
      this.element.requestSubmit()
    }
  }
}
